module.exports = __webpack_public_path__ + "static/media/allan.a403325a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/allan.png
// module id = 57
// module chunks = 0